import { Stack, Text } from "@mantine/core";
import { DataResult, EntityClientAction, FakeProgressBar, useExecuteProc, useExportToExcel } from "@mcurros2/microm";
import { useEffect, useState } from "react";
import { Rutas } from "../Rutas/Rutas/Rutas";
import { SolicitudesRuteo } from "../SolicitudesRuteo/SolicitudesRuteo";

export const ExportarExcelRutasModal = ({ rutas, onClose }: { rutas: Rutas, onClose: () => void }) => {
    const getRutas = useExecuteProc(rutas, rutas.def.procs.ruta_qryExportar);

    const [datos0, setDatos0] = useState<DataResult>();

    const { exportToExcel } = useExportToExcel({
        data: [datos0!],
        dataResultNames: ['Rutas']
    });

    useEffect(() => {
        async function fetchData() {
            await getRutas.execute({});
        }
        fetchData();
    }, []);

    useEffect(() => {
        if (!getRutas.status.loading && getRutas.status.data) {
            setDatos0(getRutas.status.data[0]);
        }
    }, [getRutas.status]);

    useEffect(() => {
        if (datos0) {
            exportToExcel();
            onClose();
        }
    }, [datos0]);

    return (
        <Stack>
            <Text>Generando archivo...</Text>
            <FakeProgressBar />
        </Stack>
    )
};


export const ACTExportarRutas: EntityClientAction = {
    name: 'ACTExportarRutas',
    label: 'Exportar Rutas',
    title: <Text fw={700}>Exportar Rutas</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: ['soru_brwDisponibleEnRutas'],
    onClick: async ({ entity, modal, element, onClose }) => {
        const solicitudesRuteo = entity as SolicitudesRuteo;
        const rutas = new Rutas(solicitudesRuteo.API.client);

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        await modal.open({
            modalProps: {
                title: <Text fw="700">Exportar Rutas</Text>
            },
            focusOnClosed: element,
            content: <ExportarExcelRutasModal rutas={rutas} onClose={() => modal.close()} />

        });

        return false;
    }
}